import React, { Fragment, useReducer } from "react";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Dropdown, Modal, Tab, Nav } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
// import lgThumbnail from 'lightgallery/plugins/thumbnail';
// import lgZoom from 'lightgallery/plugins/zoom';

//** Import Image */
// import profile02 from "../../../../images/profile/2.jpg";
// import profile03 from "../../../../images/profile/3.jpg";
// import profile04 from "../../../../images/profile/4.jpg";
// import profile from "../../../../images/profile/profile.png";
import PageTitle from "../../../layouts/PageTitle";

import { getAuth, updatePassword } from "firebase/auth";
import Swal from "sweetalert2";
import config from '../../../../config';

// const galleryBlog = [
// 	{image: profile03}, {image: profile04},
// 	{image: profile02}, {image: profile04},
// 	{image: profile03}, {image: profile02},
// ];
const initialState = false;
const reducer = (state, action) =>{
	switch (action.type){
		case 'sendMessage':
			return { ...state, sendMessage: !state.sendMessage }		
		case 'postModal':
			return { ...state, post: !state.post }
		case 'linkModal':
			return { ...state, link: !state.link }		
		case 'cameraModal':
			return { ...state, camera: !state.camera }		
		case 'replyModal':
			return { ...state, reply: !state.reply }
		default:
			return state	
	}	
}

const AppProfile = () => {

	const user = useSelector((state) => state.auth?.user);
	const isAdmin = user?.role === "Admin";


	//Profile Detail
	const [showPersonalModal, setShowPersonalModal] = useState(false);
	const openPersonalModal = () => setShowPersonalModal(true);
	const closePersonalModal = () => setShowPersonalModal(false);

	//Contact Detail
	const [showContactModal, setShowContactModal] = useState(false);
	const openContactModal = () => setShowContactModal(true);
	const closeContactModal = () => setShowContactModal(false);

	//Professional Detail
	const [showProfessionalModal, setShowProfessionalModal] = useState(false);
	const openProfessionalModal = () => setShowProfessionalModal(true);
	const closeProfessionalModal = () => setShowProfessionalModal(false);

	//Employment Detail
	const [showSchoolModal, setShowSchoolModal] = useState(false);
	const openSchoolModal = () => setShowSchoolModal(true);
	const closeSchoolModal = () => setShowSchoolModal(false);

	//Administrative Detail
	const [showAdminModal, setShowAdminModal] = useState(false);
	const openAdminModal = () => setShowAdminModal(true);
	const closeAdminModal = () => setShowAdminModal(false);

	//Profile Pic Modal
	const [showPhotoModal, setShowPhotoModal] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);


	const [profile, setProfile] = useState({});
	const [loading, setLoading] = useState(true);


	const [newPassword, setNewPassword] = React.useState("");
	const [confirmPassword, setConfirmPassword] = React.useState("");

	const [activeModal, setActiveModal] = React.useState(null);


	const onInit = () => {
		//console.log('lightGallery has been initialized');
	};

		
	useEffect(() => {
		if (!user?.uid) return;
		loadProfile();
	}, [user]);


	const loadProfile = async () => {
		const res = await fetch(`${config.apiBaseUrl}/get-profile.php`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ uid: user.uid }),
		});

		const data = await res.json();
		setProfile(data);
		setLoading(false);
	};


	const handlePasswordChange = async () => {
		if (newPassword.length < 6) {
			Swal.fire("Error", "Password must be at least 6 characters", "error");
			return;
		}

		if (newPassword !== confirmPassword) {
			Swal.fire("Error", "Passwords do not match", "error");
			return;
		}

		try {
			const auth = getAuth();
			const user = auth.currentUser;

			await updatePassword(user, newPassword);

			Swal.fire("Success", "Password updated!", "success");

			setNewPassword("");
			setConfirmPassword("");
		} catch (error) {
			Swal.fire("Error", "Please login again to change password", "error");
		}
	};

  	const options = {
     	settings: {
			overlayColor: "#000000",
     	},
 	};

	const [state, dispatch] = useReducer(reducer, initialState);

	if (!user) return <div>Loading user...</div>;


	const saveProfile = async () => {
		await fetch(`${config.apiBaseUrl}/update-profile.php`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(profile),
		});

		Swal.fire("Saved", "Profile updated!", "success");

		closePersonalModal();
		closeContactModal();
		closeProfessionalModal();
	};

	//Upload photo 
	const uploadPhoto = async () => {
		if (!selectedFile) return;

		const formData = new FormData();
		formData.append("photo", selectedFile);
		formData.append("uid", user.uid);

		const res = await fetch(
			`${config.apiBaseUrl}/upload-photo.php`,
			{
				method: "POST",
				body: formData,
			}
		);

		const data = await res.json();

		setProfile({ ...profile, profile_photo: data.url });
		setShowPhotoModal(false);
	};


	return (
		<Fragment>
		  <PageTitle activeMenu="Profile" motherMenu="App" />	
		  <div className="row">
			<div className="col-lg-12">
			  <div className="profile card card-body px-3 pt-3 pb-0">
				<div className="profile-head">
				  <div className="photo-content ">
					<div className="cover-photo rounded"></div>
				  </div>
				  <div className="profile-info">

					{/* Profile Photo */}
					<div className="profile-photo">
						<img
						src={profile.profile_photo || "/default-user.png"}
						className="img-fluid rounded-circle"
						alt="profile"
						style={{ cursor: "pointer" }}
						onClick={() => setShowPhotoModal(true)}
						/>
					</div>

					{/* Details */}
					<div className="profile-details">

						<div className="profile-name px-3 pt-2">
						<h4 className="text-primary mb-0">
							{profile.fullname || user.fullname}
						</h4>
						<p>{user.role}</p>
						</div>

						<div className="profile-email px-2 pt-2">
						<h4 className="text-muted mb-0">
							{profile.email || user.email}
						</h4>
						<p>Email</p>
						</div>

					</div>
				  </div>

				</div>
			  </div>
			</div>
		  </div>
		  


		  <div className="row">	
			<div className="col-xl-12">
			  <div className="card">
				<div className="card-body">
				  <div className="profile-tab">
					<div className="custom-tab-1">
						<Tab.Container defaultActiveKey='Personal'>					
							<Nav as='ul' className="nav nav-tabs">
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#personal" eventKey='Personal'>Personal Details</Nav.Link>
								</Nav.Item>
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#contact"  eventKey='Contact'>Contact Details</Nav.Link>
								</Nav.Item>
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#professional" eventKey='Professional'>Professional Details</Nav.Link>
								</Nav.Item>
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#employment" eventKey="Employment">Employment Details</Nav.Link>
								</Nav.Item>
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#dministrative" eventKey='Administrative'>Administrative Fields</Nav.Link>
								</Nav.Item>
								<Nav.Item as='li'>
									<Nav.Link eventKey='Password'>Change Password</Nav.Link>
								</Nav.Item>
							</Nav>
							<Tab.Content>								
								<Tab.Pane id="personal" eventKey='Personal'>	
									<div className="pt-3">								
										<div className="profile-personal-info">
											<h4 className="text-primary mb-4">
												Personal Details
											</h4>
											<div className="row mb-2">
												<div className="col-3"><h5>Full Name :</h5></div>
												<div className="col-9"><span>{profile.fullname}</span></div>
											</div>
											<div className="row mb-2">
												<div className="col-3"><h5>Sex :</h5></div>
												<div className="col-9"><span>{profile.gender}</span></div>
											</div>
											<div className="row mb-2">
												<div className="col-3"><h5>Date of Birth :</h5></div>
												<div className="col-9"><span>{profile.dob}</span></div>
											</div>
											<div className="row mb-2">
												<div className="col-3"><h5>Blood Group :</h5></div>
												<div className="col-9"><span>{profile.blood_group}</span></div>
											</div>
											<div className="text-start mt-3">
												<Button onClick={openPersonalModal}>
													Edit Personal Details
												</Button>
											</div>
										</div>
									</div>
								</Tab.Pane>
								<Tab.Pane id="contact" eventKey='Contact'>
									<div className="profile-personal-info">
										<h4 className="text-primary mb-4">Contact Details</h4>

										<div className="row mb-2">
											<div className="col-3"><h5>Email :</h5></div>
											<div className="col-9"><span>{profile.email}</span></div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Phone :</h5></div>
											<div className="col-9"><span>{profile.phoneno || "-"}</span></div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Address :</h5></div>
											<div className="col-9"><span>{profile.address || "-"}</span></div>
										</div>

										<button className="btn btn-primary mt-3" onClick={openContactModal}>
											Edit Contact Details
										</button>
									</div>
								</Tab.Pane>

								<Tab.Pane id="professional" eventKey="Professional">
									<div className="profile-personal-info">
										<h4 className="text-primary mb-4">Professional Details</h4>

										<div className="row mb-2">
											<div className="col-3"><h5>Qualification :</h5></div>
											<div className="col-9">
												<span>{profile.qualification || "-"}</span>
											</div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Department :</h5></div>
											<div className="col-9">
												<span>{profile.department || "-"}</span>
											</div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Joining Date :</h5></div>
											<div className="col-9">
												<span>{profile.joining_date || "-"}</span>
											</div>
										</div>

										<Button className="mt-3" onClick={openProfessionalModal}>
											Edit Professional Details
										</Button>
									</div>
								</Tab.Pane>

								<Tab.Pane id="employment" eventKey="Employment">
									<div className="profile-personal-info">
										<h4 className="text-primary mb-4">Employment Details</h4>
										<div className="row mb-2">
											<div className="col-3"><h5>Employee ID :</h5></div>
											<div className="col-9">
												<span>{profile.employee_id || "-"}</span>
											</div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Designation :</h5></div>
											<div className="col-9">
												<span>{profile.designation || "-"}</span>
											</div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Assigned Class :</h5></div>
											<div className="col-9">
												<span>{profile.assigned_class || "-"}</span>
											</div>
										</div>

										<div className="row mb-2">
											<div className="col-3"><h5>Subjects :</h5></div>
											<div className="col-9">
												<span>{profile.subjects || "-"}</span>
											</div>
										</div>

										<Button className="mt-3" onClick={openSchoolModal}>
											Edit Employment Details
										</Button>
									</div>
								</Tab.Pane>

								<Tab.Pane id="administrative" eventKey='Administrative'>
									<div className="pt-3">
										<div className="settings-form">
											<h4 className="text-primary">Administrative Details</h4>
											<div className="row mb-2">
												<div className="col-3"><h5>Status :</h5></div>
												<div className="col-9"><span>{profile.status}</span></div>
											</div>
											<div className="row mb-2">
												<div className="col-3"><h5>Created :</h5></div>
												<div className="col-9"><span>{profile.created_at}</span></div>
											</div>
											<div className="text-start mt-3">
												<Button onClick={openAdminModal} disabled={!isAdmin}>
													Edit Administrative Settings
												</Button>
											</div>
										</div>
									</div>
								</Tab.Pane>
								<Tab.Pane eventKey='Password'>
									<div className="pt-3">
										<div className="settings-form">
										<h4 className="text-primary">Change Password</h4>

										<div className="mb-3">
											<label>New Password</label>
											<input
											type="password"
											className="form-control"
											value={newPassword}
											onChange={(e) => setNewPassword(e.target.value)}
											/>
										</div>

										<div className="mb-3">
											<label>Confirm Password</label>
											<input
											type="password"
											className="form-control"
											value={confirmPassword}
											onChange={(e) => setConfirmPassword(e.target.value)}
											/>
										</div>

										<Button onClick={handlePasswordChange}>
											Update Password
										</Button>
										</div>
									</div>
								</Tab.Pane>
							</Tab.Content>	
						</Tab.Container>		
					</div>
				  </div>
				</div>
			  </div>
			</div>
		  </div>

		  {/* Modal for profile  */}
		  <Modal show={showPersonalModal} onHide={closePersonalModal} centered>
			<Modal.Header closeButton>
				<Modal.Title>Edit Personal Details</Modal.Title>
			</Modal.Header>

			<Modal.Body>

				{/* Full Name */}
				<div className="mb-3">
				<label className="form-label">Full Name</label>
				<input
					className="form-control"
					value={profile.fullname || ""}
					onChange={(e) =>
					setProfile({ ...profile, fullname: e.target.value })
					}
				/>
				</div>

				{/* Gender */}
				<div className="mb-3">
				<label className="form-label mb-2">Gender</label>

				<div className="d-flex gap-4">

					<div className="form-check">
					<input
						type="radio"
						className="form-check-input"
						id="genderMale"
						value="Male"
						checked={profile.gender === "Male"}
						onChange={(e) =>
						setProfile({ ...profile, gender: e.target.value })
						}
					/>
					<label className="form-check-label" htmlFor="genderMale">
						Male
					</label>
					</div>

					<div className="form-check">
					<input
						type="radio"
						className="form-check-input"
						id="genderFemale"
						value="Female"
						checked={profile.gender === "Female"}
						onChange={(e) =>
						setProfile({ ...profile, gender: e.target.value })
						}
					/>
					<label className="form-check-label" htmlFor="genderFemale">
						Female
					</label>
					</div>

					<div className="form-check">
					<input
						type="radio"
						className="form-check-input"
						id="genderOther"
						value="Other"
						checked={profile.gender === "Other"}
						onChange={(e) =>
						setProfile({ ...profile, gender: e.target.value })
						}
					/>
					<label className="form-check-label" htmlFor="genderOther">
						Other
					</label>
					</div>

				</div>
				</div>

				{/* Blood Group */}
				<div className="mb-3">
				<label className="form-label">Blood Group</label>

				<select
					className="form-control"
					value={profile.blood_group || ""}
					onChange={(e) =>
					setProfile({ ...profile, blood_group: e.target.value })
					}
				>
					<option value="">Select Blood Group</option>
					<option>A+</option>
					<option>A-</option>
					<option>B+</option>
					<option>B-</option>
					<option>AB+</option>
					<option>AB-</option>
					<option>O+</option>
					<option>O-</option>
				</select>
				</div>

				{/* Date of Birth */}
				<div className="mb-3">
				<label className="form-label">Date of Birth</label>
				<input
					type="date"
					className="form-control"
					value={profile.dob || ""}
					onChange={(e) =>
					setProfile({ ...profile, dob: e.target.value })
					}
				/>
				</div>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={closePersonalModal}>
				Cancel
				</Button>

				<Button variant="primary" onClick={saveProfile}>
				Save Changes
				</Button>
			</Modal.Footer>
		</Modal>

		{/* Contact Detail Modal  */}
		<Modal show={showContactModal} onHide={closeContactModal}>
			<Modal.Header closeButton>
				<Modal.Title>Edit Contact Details</Modal.Title>
			</Modal.Header>

			<Modal.Body>

				<div className="mb-3">
					<label>Email</label>
					<input
						className="form-control"
						value={profile.email || ""}
						disabled
					/>
					<small className="text-muted">
						Email is managed by system
					</small>
				</div>

				<div className="mb-3">
					<label>Phone Number</label>
					<input
						className="form-control"
						value={profile.phoneno || ""}
						onChange={(e) =>
							setProfile({ ...profile, phoneno: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Address</label>
					<textarea
						className="form-control"
						rows="3"
						value={profile.address || ""}
						onChange={(e) =>
							setProfile({ ...profile, address: e.target.value })
						}
					/>
				</div>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={closeContactModal}>
					Cancel
				</Button>

				<Button variant="primary" onClick={saveProfile}>
					Save Changes
				</Button>
			</Modal.Footer>
		</Modal>

		{/* Professional Detail Modal  */}
		<Modal show={showProfessionalModal} onHide={closeProfessionalModal}>
			<Modal.Header closeButton>
				<Modal.Title>Edit Professional Details</Modal.Title>
			</Modal.Header>

			<Modal.Body>

				<div className="mb-3">
					<label>Qualification</label>
					<input
						className="form-control"
						value={profile.qualification || ""}
						onChange={(e) =>
							setProfile({ ...profile, qualification: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Department</label>
					<input
						className="form-control"
						value={profile.department || ""}
						onChange={(e) =>
							setProfile({ ...profile, department: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Joining Date</label>
					<input
						type="date"
						className="form-control"
						value={profile.joining_date || ""}
						onChange={(e) =>
							setProfile({ ...profile, joining_date: e.target.value })
						}
					/>
				</div>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={closeProfessionalModal}>
					Cancel
				</Button>

				<Button variant="primary" onClick={saveProfile}>
					Save Changes
				</Button>
			</Modal.Footer>
		</Modal>

		{/* School Details Modal  */}
		<Modal show={showSchoolModal} onHide={closeSchoolModal}>
			<Modal.Header closeButton>
				<Modal.Title>Edit Employment Details</Modal.Title>
			</Modal.Header>

			<Modal.Body>

				<div className="mb-3">
					<label>Employee ID</label>
					<input
						className="form-control"
						value={profile.employee_id || ""}
						onChange={(e) =>
							setProfile({ ...profile, employee_id: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Designation</label>
					<input
						className="form-control"
						value={profile.designation || ""}
						onChange={(e) =>
							setProfile({ ...profile, designation: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Assigned Class</label>
					<input
						className="form-control"
						value={profile.assigned_class || ""}
						onChange={(e) =>
							setProfile({ ...profile, assigned_class: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Subjects</label>
					<input
						className="form-control"
						value={profile.subjects || ""}
						onChange={(e) =>
							setProfile({ ...profile, subjects: e.target.value })
						}
					/>
				</div>

				<div className="mb-3">
					<label>Employment Type</label>
					<select
						className="form-control"
						value={profile.employment_type || ""}
						onChange={(e) =>
							setProfile({ ...profile, employment_type: e.target.value })
						}
					>
						<option value="">Select</option>
						<option>Permanent</option>
						<option>Contract</option>
						<option>Part-time</option>
					</select>
				</div>

				<div className="mb-3">
					<label>Reporting To</label>
					<input
						className="form-control"
						value={profile.reporting_to || ""}
						onChange={(e) =>
							setProfile({ ...profile, reporting_to: e.target.value })
						}
					/>
				</div>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={closeSchoolModal}>
					Cancel
				</Button>

				<Button variant="primary" onClick={saveProfile}>
					Save Changes
				</Button>
			</Modal.Footer>
		</Modal>

		{/* Administrative Modal  */}
		<Modal show={showAdminModal} onHide={closeAdminModal}>
			<Modal.Header closeButton>
				<Modal.Title>Administrative Settings</Modal.Title>
			</Modal.Header>

			<Modal.Body>

				{!isAdmin && (
				<div className="alert alert-warning">
					Only administrators can modify administrative fields.
				</div>
				)}

				{/* Account Status */}
				<div className="mb-3">
				<label>Account Status</label>
				<select
					className="form-control"
					value={profile.status || "Active"}
					disabled={!isAdmin}
					onChange={(e) =>
					setProfile({ ...profile, status: e.target.value })
					}
				>
					<option>Active</option>
					<option>Suspended</option>
					<option>Inactive</option>
				</select>
				</div>

				{/* Role */}
				<div className="mb-3">
				<label>User Role</label>
				<select
					className="form-control"
					value={profile.role || ""}
					disabled={!isAdmin}
					onChange={(e) =>
					setProfile({ ...profile, role: e.target.value })
					}
				>
					<option>Admin</option>
					<option>Teacher</option>
					<option>Staff</option>
				</select>
				</div>

				{/* Login Enabled */}
				<div className="mb-3">
				<label>Login Access</label>
				<select
					className="form-control"
					value={profile.login_enabled || "Yes"}
					disabled={!isAdmin}
					onChange={(e) =>
					setProfile({ ...profile, login_enabled: e.target.value })
					}
				>
					<option value="Yes">Enabled</option>
					<option value="No">Disabled</option>
				</select>
				</div>

				{/* Force password reset */}
				<div className="mb-3">
				<label>Force Password Reset</label>
				<select
					className="form-control"
					value={profile.force_reset || "No"}
					disabled={!isAdmin}
					onChange={(e) =>
					setProfile({ ...profile, force_reset: e.target.value })
					}
				>
					<option>No</option>
					<option>Yes</option>
				</select>
				</div>

				{/* Read-only system info */}

				<hr />

				<div className="mb-2">
				<strong>Last Login:</strong>
				<div>{profile.last_login || "Never"}</div>
				</div>

				<div className="mb-2">
				<strong>Account Created:</strong>
				<div>{profile.created_at || "-"}</div>
				</div>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={closeAdminModal}>
				Close
				</Button>

				<Button
				variant="primary"
				onClick={saveProfile}
				disabled={!isAdmin}
				>
				Save Changes
				</Button>
			</Modal.Footer>
		</Modal>

		{/* //Profile picture Upload Modal  */}
		<Modal show={showPhotoModal} onHide={() => setShowPhotoModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>Upload Profile Picture</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				{/* <input
					type="file"
					accept="image/*"
					className="form-control"
					onChange={(e) => setSelectedPhoto(e.target.files[0])}
				/> */}
				<input
					type="file"
					accept="image/*"
					className="form-control"
					onChange={(e) => setSelectedFile(e.target.files[0])}
				/>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={() => setShowPhotoModal(false)}>
				Cancel
				</Button>

				<Button variant="primary" onClick={uploadPhoto}>
				Upload
				</Button>
			</Modal.Footer>
		</Modal>


		</Fragment>
	  );
};

export default AppProfile;